export default __webpack_public_path__ + "static/media/photoshop-line.5172c277.svg";